<script>
    import CRUD from './CRUD.svelte';
    import { fetchCorredores, saveCorredor, removeCorredor, searchCorredores, subscribeToCorredores, unsubscribeFromCorredores } from '../controllers/corredorController.js';

    // Configuración de las columnas para la tabla de corredors
    let corredorColumns = [
      { label: 'Nombre', field: 'nombre', type: 'text' },
      { label: 'Estado', field: 'sta', type: 'bool' },
    ];

    // Estructura del nuevo objeto Corredor
    let newCorredor = {
      id: '',
      nombre: '',
      sta: true,
    };

    // Configuración de los campos para la edición de corredors
    let editColumns = [
        { label: 'Nombre', key: 'nombre', type: 'text', required: true },
        { label: 'Estado', key: 'sta', type: 'checkbox', required: true }
    ];
</script>

<CRUD 
    title="Corredores"
    entityName="corredor"
    newEntity={newCorredor}
    columns={corredorColumns}
    fetchEntities={fetchCorredores}
    saveEntity={saveCorredor}
    removeEntity={removeCorredor}
    searchEntities={searchCorredores}
    subscribeToChanges={subscribeToCorredores}
    unsubscribeFromChanges={unsubscribeFromCorredores}
    editColumns={editColumns}
/>